import type { SiteConfig } from '../../@types/context/site-config.types';
import { insuranceMypageNo } from './insurance-mypage.config';

export const sitePathZmartaNoConfig: Pick<SiteConfig, 'path'> = {
  path: {
    loansApply: '/lane-penger/forbrukslan/lanesoknad',
    oneFormPreflight: '/soknad/forhandssjekk',
    oneFormApply: '/soknad/lan',
    oneFormRecommendations: '/soknad/lan/anbefalinger',
    mypage: '/mine-tilbud/forbrukslan',
    mypageOverview: '/mine-tilbud',
    mypageLoans: '/mine-tilbud/forbrukslan',
    mypageCreditCards: '/mine-tilbud/kredittkort',
    mypageSecuredLoans: '/mine-tilbud/lan-med-sikkerhet',
    insurance: '/soknad/forsikring',
    creditCard: '/kredittkort/soknad',
    ...insuranceMypageNo,
  },
};
